import { PlusOutlined } from "@ant-design/icons"
import { Button, Empty, Flex, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

const { Text } = Typography

interface ReportsEmptyProps {
  hasFilters?: boolean
  onCreate: () => void
}

export function ReportsEmpty({ hasFilters, onCreate }: ReportsEmptyProps) {
  const { t } = useTranslation()

  const content = hasFilters ? (
    <Flex vertical className="text-center py-3">
      <Text type="secondary" strong>
        {t("reports.empty.noResultsTitle")}
      </Text>
      <Text type="secondary" className="mt-1">
        {t("reports.empty.noResultsSubtitle")}
      </Text>
    </Flex>
  ) : (
    <Flex vertical align="center" className="text-center py-3" gap="small">
      <Text type="secondary" strong>
        {t("reports.empty.title")}
      </Text>
      <Button type="primary" icon={<PlusOutlined />} onClick={onCreate}>
        {t("reports.newReport")}
      </Button>
    </Flex>
  )

  return <Empty description={content} />
}
